export default {
    'add-a-account': "إضافة حساب",
    logout: "تسجيل خروج",
    'a-message-to-a-student': 'رسالة لطالب'
}